const templateUrl = require('./../views/elements/feet.html');
const feetDirective = () => {
  return {
    templateUrl,
    restrict: 'E'
  }
};

export default feetDirective;



// WEBPACK FOOTER //
// ./js/containers/core/directives/feet.js